import React from "react";
import classnames from "classnames/bind";

import styles from "./SelectShare.module.scss";

const cx = classnames.bind(styles);

export const SelectGroup = ({ group, handleGroup }) => (
  <select className={cx("select", "group")} onChange={handleGroup} value={group}>
    {[
      ["", "쇼핑몰/브랜드"],
      ["default", "쇼핑몰"],
      ["brand", "브랜드"]
    ].map(([en, ko]) => (
      <option key={en} value={en}>
        {ko}
      </option>
    ))}
  </select>
);
